<template>
  <app-filter-group @query="search"
    :query-loading="queryLoading"
    @reset="reset">
    <gj-category-select multiple
      v-model="filter.categoryIds"
      :collapse-tags="true"
      placeholder="全部品类"
      width="150px">
    </gj-category-select>
    <gj-brand-select v-model="filter.brandIds"
      multiple
      collapseTags
      placeholder="全部品牌"
      width="150px">
    </gj-brand-select>
    <gj-select v-model="filter.currency"
      :options="option.statisticsCurrency"
      :clearable="false">
    </gj-select>
    <gj-date-picker v-model="filter.date"
      type="daterange"
      :clearable="false">
    </gj-date-picker>
    <gj-select-input v-model="filter.keyword"
      :options="keywordOptions">
    </gj-select-input>
    <slot></slot>
    <template #right>
      <slot name="right"></slot>
      <view-setting :ref="REF_VIEW_SETTING"
        save-mode="remote"
        :use-default="true"
        :module-name="moduleName"
        :config="model"
        :fn-generate-params="generateViewParams"
        @view-change="handleChangeView">
      </view-setting>
    </template>
  </app-filter-group>
</template>

<script>
  import {financeCurrencysOption} from "@/utils/options";
  import {convertToDate, generateViewParams } from "@/utils/date.util";
  import {DATE_SHORTCUTS} from "@/utils/const";
  import viewConfig from './viewConfig'
  import { queryMixin } from "@/minxins";

  export default {
    name: "product-analysis-filter",
    created() {
      this.search();
    },
    mixins: [queryMixin],
    props: {
      filter: {
        type: Object,
        default () {
          return {}
        }
      },
      queryLoading: {
        default:false
      }
    },
    data() {
      return {
        option: {
          statisticsCurrency: financeCurrencysOption.filter(item => item.text !== '原币种'),
        },
        model: viewConfig,
        keywordOptions:[
          {id: 'sku', text: 'SKU'},
          {id: 'msku', text: 'MSKU'},
          {id: 'productName', text: '产品名称'},
        ]
      }
    },
    computed: {
      moduleName () {
        return `PRODUCT_ANALYSIS_FILER_${this.$route.name}`
      }
    },
    methods: {
      generateViewParams,
      /**
       * 切换视图
       */
      async handleChangeView (view) {
        if (view && view.params) {
          try {
            let params = JSON.parse(view.params)
            if (params && this.mergeRemoteParams && typeof this.mergeRemoteParams === 'function') {
              this.mergeRemoteParams(params)
            }
            this.search()
          } catch (e) {
            console.warn(e)
          }
        } else {
          this.reset()
        }

      },
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        const date = params.date ? params.date : [params.startDateTime, params.endDateTime]
        Object.assign(this.filter, {
          ...params,
          date
        })
      },
      search(type = 'search') {
        const params = {
          ...this.filter,
          startStatisticsDate: convertToDate(this.filter.date[0]),
          endStatisticsDate: convertToDate(this.filter.date[1]),
        };
        params[this.filter.keyword.key] = this.filter.keyword.value;
        this.$emit(type, params);
      },
      reset() {
        this.filter.currency = 'USD';
        this.filter.categoryIds = null;
        this.filter.brandIds = null;
        this.filter.keyword = {
          key: 'sku',
          value: null,
        };
        this.filter.date = DATE_SHORTCUTS.last14Day.date;
        this.filter.userPermission = null;
        this.search('reset')
      }
    }
  }
</script>